<div class="d-flex justify-content-between align-items-center checklist-header">
  <div class="cc-tile-with-backBtn">
    <div class="title-backBtn" (click)="backToServicePage()"><span class="fas fa-long-arrow-alt-left"></span></div>
    <h3>{{addStatus}} {{'_Checklist_Header_Text_' | translate }} {{serviceName}}</h3>
  </div>
  <!--<button kendoGridAddCommand [disabled]="(gridData.data.length >= 10)" [ngClass]="'btn btn-primary'">Add Checklist Item</button>-->
  <button *ngIf="userPermissionList.includes(50)"
    [disabled]="(gridData.data.length >= 10 || addingNewItem || editingItem)" class="btn btn-primary"
    (click)="addHandler(grid)">{{'_Add_Checklist_Item_Button_Text_' | translate }}</button>
</div>

<div class="cc-content-wrapper add-checklist-wrapper">

  <!--User Grid-->
  <div>

    <kendo-grid #grid [data]="gridData" [pageable]="false" [skip]="state.skip" [pageSize]="state.take" scrollable="scrollable"
      [rowClass]="rowCallback" (dataStateChange)="dataStateChange($event)" (edit)="editHandler($event)"
      (cancel)="cancelHandler($event)" (save)="saveHandler($event)" (remove)="removeHandler($event)"
      (add)="addHandler($event.sender)">
      <!-- <ng-template kendoGridToolbarTemplate>
        <button kendoGridAddCommand [disabled]="(gridData.data.length >= 10)" [ngClass]="'btn btn-primary'">Add Checklist Item</button>
        <button *ngIf="userPermissionList?.includes(50)"
          [disabled]="(gridData.data.length >= 10 || addingNewItem || editingItem)" class="btn btn-primary m-3"
          (click)="addHandler(grid)">Add Checklist Item</button>
      </ng-template> -->
      <kendo-grid-messages pagerFirstPage="{{'_Go_To_First_Page_Text_' | translate}}" pagerLastPage="{{'_Go_To_Last_Page_Text_' | translate}}" pagerNextPage="{{'_Go_To_Next_Page_Text_' | translate}}" pagerPreviousPage="{{'_Go_To_Previous_Page_Text_' | translate}}" pagerPage="{{'_Page_Grid_Text_' | translate}}" noRecords="{{'_NoRecords_Grid_Text_' | translate}}" pagerItems="{{'_General_Kendo_Grid_Pageable_Items_Text_' | translate}}" pagerOf="{{'_General_Kendo_Grid_Pageable_Of_Text_' | translate}}"></kendo-grid-messages>
      <kendo-grid-column field="language" title="{{'_General_Language_Text_' | translate }}" [width]="120" [headerStyle]="{'font-weight' : 'bold'}">
        <ng-template kendoGridEditTemplate let-formGroup="formGroup" let-dataItem="dataItem" let-column="column">
          <select
            class="cc-select-dropdown form-control"
            [(ngModel)]="dataItem.language"
            [formControl]="formGroup.get(column.field)"
            (change)="onLanguageChange(dataItem)">
            <option *ngFor="let lang of languages; trackBy: languageTrackBy" [ngValue]="lang">{{lang.languageName | translate}}</option>
          </select>
        </ng-template>
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <div class="checklist-item">
            <span
              [ngClass]="draggable && !editingItem ? 'k-icon k-i-pan checklist-item-drag-enabled' : 'k-icon k-i-pan checklist-item-drag-disabled'"
              title="{{'_Checklist_Item_Display_Order_Message_Text_' | translate }}"></span>
            <div class="checklist-item-name ">{{dataItem.language.languageName | translate }}</div>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="checklistItem" title="{{'_Checklist_Item_Column_Title_Text_' | translate }}" [width]="250"
        [headerStyle]="{'font-weight' : 'bold'}">
        <ng-template kendoGridEditTemplate let-formGroup="formGroup" let-dataItem="dataItem" let-column="column">
          <input #checklistItem app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$"
            [(ngModel)]="dataItem.checklistItem" kendoGridFocusable name="checklistItem" class="form-control" maxlength=60
            [formControl]="formGroup.get(column.field)" />
          <!-- <kendo-popup
                  [anchor]="checklistItem"
                  *ngIf="formGroup.get(column.field).invalid && !(formGroup.get(column.field).untouched)"
                  popupClass="k-widget k-tooltip k-tooltip-validation k-invalid-msg"
                 >
                  <span class="k-icon k-i-warning"></span>
                  Checklist Item is required
                </kendo-popup> -->
          <div>
            <div *ngIf="formGroup.get(column.field).invalid && !(formGroup.get(column.field).untouched)"
              class="cc-validation opt-hours-validation">
              {{'_Checklist_Item_Required_Validation_Message_' | translate }}
            </div>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="linkName" title="{{'_Text_Display_Column_Title_Text_' | translate }}" [width]="200" [headerStyle]="{'font-weight' : 'bold'}">
        <ng-template kendoGridEditTemplate let-formGroup="formGroup" let-dataItem="dataItem" let-column="column">
          <input #linkName app-filter pattern="^((?=[^<>&])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^_*\(\)~=\{\}:;+'&quot;.\-;,])*$"
            [(ngModel)]="dataItem.linkName" kendoGridFocusable name="linkName" class="form-control" maxlength=60
            [formControl]="formGroup.get(column.field)" />
        </ng-template>
      </kendo-grid-column>
      <!-- CC-479 hide Link URL Header -->
      <kendo-grid-column field="link" title="{{'_Link_Url_Title_Text_' | translate }}" [width]="300" [headerStyle]="{'font-weight' : 'bold'}" [hidden]="true">
        <ng-template kendoGridEditTemplate let-formGroup="formGroup" let-dataItem="dataItem" let-column="column">
          <input #link app-filter pattern="^((?=[^<>])[A-Za-z0-9`\s\|!@?#\\$\/%\[\]^&_*\(\)~=\{\}:;+'&quot;.\-;,])*$"
            [(ngModel)]="dataItem.link" kendoGridFocusable name="linkUrl" class="form-control" maxlength=250
            [formControl]="formGroup.get(column.field)" />
          <div>
            <div *ngIf="formGroup.get(column.field).invalid" class="cc-validation opt-hours-validation">
              {{'_Invalid_Link_Url_Validation_Message_' | translate }}
            </div>
          </div>
        </ng-template>
      </kendo-grid-column> -->
      <kendo-grid-command-column title="{{'_General_Button_Action_Text_' | translate }}" [width]="150" [headerStyle]="{'font-weight' : 'bold', 'text-align':'center', 'justify-content': 'center'}">
        <ng-template kendoGridCellTemplate let-dataItem let-isNew="isNew">
          <div class="cell-items-center">
            <button *ngIf="userPermissionList?.includes(51)" kendoGridEditCommand type="button"
              [iconClass]="'fas fa-pen cc-icon-btn'" title="{{'_General_Button_Edit_Text_' | translate }}" [disabled]="editingItem"></button>
            <button *ngIf="userPermissionList?.includes(52)" kendoGridRemoveCommand type="button"
              [iconClass]="'fas fa-trash-alt cc-icon-btn'" title="{{'_General_Button_Delete_Text_' | translate }}" [disabled]="editingItem"></button>
            <button kendoGridSaveCommand type="button" [iconClass]="'fas fa-save cc-icon-btn'" title="{{'_General_Button_Save_Text_' | translate }}"
              [disabled]="(formGroup?.invalid || formGroup?.pristine ||
              !isEnglishCheckListItemValueEntered()) ? true: false"></button>
            <button kendoGridCancelCommand type="button" [iconClass]="'fas fa-times cc-icon-btn'" title="{{'_General_Button_Cancel_Text_' | translate }}"></button>
          </div>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>

<app-modalpopup header="{{'_Delete_Checklist_Popup_Header_Text_' | translate }}" [(dialogOpened)]="opened" [isInfo]="false" actionNoLabel="{{'_General_Action_Label_No_Text_' | translate }}"
  actionYesLabel="{{'_General_Action_Label_Yes_Text_' | translate }}"
  [message]="('_Delete_Checklist_Popup_Confirm_Message_Text_' | translate)+ ' ' +checklistToRemove.checklistItem+'?'"
  (submitted)="close('Yes')" (cancelled)="close('No')">
</app-modalpopup>
